export default {
    "navigation": {
        "allWatchfaces": "Усі додатки",
        "faq": "Питання та відповіді",
        "helpCenter": "Допомога та інструкції",
        "newsletter": "Розсилка",
        "contact": "Контакт",
        "weatherProvider": "Провайдер погоди",
        "tides": "Припливи",
        "colors": "Кольори",
        "fonts": "Шрифти"
    },
    "homepage": {
        "title": "Додатки TitanicTurtle",
        "subtitle": "Сучасні додатки Garmin з розширеними функціями для всіх ваших активностей",
        "features": {
            "tides": "🌊 Припливи",
            "weather": "🌤️ Погода",
            "themes": "🎨 Кольорові теми",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Доступні циферблати",
        "newBadge": "Новинка",
        "loading": "Завантаження циферблатів...",
        "error": "Помилка завантаження",
        "retry": "Спробувати знову",
        "filter": {
            "label": "Фільтр продуктів",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "Усі",
            "noProducts": "Немає продуктів у цій категорії"
        }
    },
    "watchface": {
        "purchase": "Купити зараз",
        "buy": "Купити",
        "features": "Функції",
        "colorThemes": "Кольорові теми",
        "themeDescription": "Натисніть на тему, щоб скопіювати рядок теми та використати його в налаштуваннях циферблата.",
        "dynamicThemeSwitching": "Динамічна зміна теми",
        "sunsetSwitching": {
            "title": "🌅 Після заходу / перед східом сонця",
            "description": "Поставте знак оклику ! перед рядком теми, щоб автоматично перемикати після заходу сонця (приклад: !UEUE[UEUEEEEEEU^)."
        },
        "lowPowerSwitching": {
            "title": "🔋 У режимі енергозбереження",
            "description": "Поставте решітку # перед рядком теми для режиму енергозбереження (приклад: #UEUE[UEUEEEEEEU^)."
        },
        "themeCopied": "Рядок теми скопійовано в буфер обміну!",
        "viewDetails": "Детальніше"
    },
    "faq": {
        "title": "Часті питання",
        "subtitle": "Знайдіть відповіді на типові питання про наші циферблати",
        "tabs": {
            "search": "Пошук",
            "categories": "Категорії",
            "all": "Показати всі питання"
        },
        "category": {
            "selected": "Обрана категорія",
            "showing": "Показано",
            "items": "записів",
            "from": "з",
            "clear": "Скасувати вибір",
            "back": "Назад до категорій"
        },
        "viewAnswer": "Переглянути відповідь",
        "closeAnswer": "Закрити відповідь",
        "darkMode": {
            "enable": "Увімкнути темний режим",
            "disable": "Вимкнути темний режим",
            "light": "Світла",
            "dark": "Темна"
        },
        "search": {
            "placeholder": "Шукати допомогу...",
            "button": "Шукати",
            "suggestions": "Популярні запити",
            "tips": {
                "title": "Поради щодо пошуку",
                "keywords": "Використовуйте конкретні ключові слова, наприклад «GPS», «погода» або «налаштування»",
                "language": "Пошук працює обраною вами мовою",
                "categories": "Переглядайте категорії для структурованої допомоги"
            }
        },
        "noResults": {
            "title": "Нічого не знайдено",
            "description": "Спробуйте інші ключові слова або перегляньте категорії",
            "browseCategories": "Переглянути категорії"
        },
        "suggestions": {
            "title": "Популярні запити"
        },
        "trending": {
            "title": "Популярні запити"
        },
        "categories": {
            "title": "Перегляд за категоріями",
            "items": "записів",
            "allItems": "Усі запитання",
            "allItemsDescription": "Переглянути всі часті питання",
            "noItems": {
                "title": "У цій категорії немає записів",
                "description": "Спробуйте обрати іншу категорію"
            },
            "viewMore": "Переглянути всі записи"
        },
        "results": {
            "title": "Результати пошуку",
            "found": "результатів за запитом",
            "total": "Всього результатів",
            "bestMatch": "Найкращий збіг",
            "categories": "Категорії",
            "sortBy": "Сортувати за",
            "sort": {
                "relevance": "Релевантністю",
                "priority": "Пріоритетом",
                "category": "Категорією"
            },
            "lastUpdated": "Оновлено",
            "matchedIn": "Збіг у",
            "footer": "Не знайшли те, що шукали?",
            "browseCategories": "Переглянути категорії",
            "viewTrending": "Переглянути популярне",
            "contactSupport": "Зв’язатися з підтримкою"
        },
        "actions": {
            "copy": "Копіювати",
            "share": "Поділитися",
            "copyAnswer": "Копіювати відповідь",
            "copyAll": "Копіювати все"
        },
        "loading": "Завантаження питань...",
        "error": "Помилка завантаження",
        "retry": "Спробувати знову",
        "questions": {
            "gpsFix": {
                "question": "Що таке GPS-фіксація і як її виконати? / Чому деякі опції показують «GPS?»",
                "answer": "GPS-фіксація потрібна, щоб циферблат знав ваше місцезнаходження і правильно обчислював час сходу/заходу сонця та місяця.\n\nGPS-фіксацію можна виконати, запустивши активність і дочекавшись отримання GPS-сигналу годинником, або довгим натисканням кнопки GPS і очікуванням сигналу.\n\nПісля цього поверніться на циферблат — усі дані мають відображатися коректно."
            },
            "userData": {
                "question": "Чи збирають циферблати якісь дані користувача?",
                "answer": "Жоден циферблат TitanicTurtle не збирає та не передає дані користувача. Вони лише показують дані, надані Garmin, або виконують обчислення на їх основі (наприклад, активні калорії).\n\nУзагалі всі дані, які Garmin передає стороннім циферблатам, не персоналізовані — немає імені чи подібного, що можна було б прочитати."
            },
            "permissions": {
                "question": "Чому циферблатам потрібно стільки дозволів?",
                "answer": "Циферблатам TitanicTurtle потрібні дозволи для надання широкого спектру даних і функцій.\n\nОсь пояснення кожного:\n\n<b>Працювати у фоні, коли не активний</b> — потрібно для оновлення даних припливів/погоди від сторонніх провайдерів разом із доступом до інтернету.\n\n<b>Надсилати/отримувати дані через інтернет</b> — потрібно для оновлення даних припливів/погоди разом із роботою у фоні.\n\n<b>Читати та показувати дані з інших додатків</b> — інші додатки мають явно надавати дані для читання циферблатами. Це стосується й власних додатків Garmin, наприклад Stress або BodyBattery, які оновлюються в реальному часі. Неавторизовані дані з інших додатків читати неможливо.\n\n<b>GPS-локація</b> — потрібна для обчислення часу сходу/заходу сонця, місяця та отримання правильної погоди за місцем.\n\n<b>Історія пульсу, барометра, температури та висоти</b> — дані, що відображаються на циферблаті, лише для показу.\n\n<b>Профіль фітнесу Garmin Connect™</b> — потрібен для відображення ваги, обчислення активних калорій та енергозбережних опцій за встановленим часом сну.\n\nЦиферблати не читають персональні дані на кшталт імені чи адрес.\n\nНа жаль, ці дозволи не можна налаштувати під ваш спосіб використання циферблата — вони завжди потрібні."
            },
            "proFeatures": {
                "question": "Що означає ♛ і чому деякі екрани показують «ключ»?",
                "answer": "♛ позначає про-функції цього циферблата. Щоб розблокувати їх після 5-денного пробного періоду, можна придбати ключ розблокування.\n\n«ключ?» означає, що пробний період закінчився."
            },
            "temperatureUnits": {
                "question": "Як змінити одиниці температури?",
                "answer": "Змініть у системних налаштуваннях годинника (довге натискання кнопки меню): Система → Формат → Одиниці вимірювання."
            },
            "timeFormat": {
                "question": "Як встановити 12-годинний/24-годинний формат?",
                "answer": "Змініть у системних налаштуваннях годинника (довге натискання кнопки меню): Система → Формат → Формат часу."
            },
            "distanceUnits": {
                "question": "Як змінити одиниці відстані чи висоти?",
                "answer": "Змініть у системних налаштуваннях годинника (довге натискання кнопки меню): Система → Формат → Одиниці вимірювання."
            }
        }
    },
    "helpCenter": {
        "title": "Допомога та інструкції",
        "subtitle": "Знайдіть відповіді, інструкції та поради для вашого циферблата",
        "guidesTitle": "Інструкції та поради",
        "faqTitle": "Часті питання",
        "allCategories": "Усі",
        "guides": "Інструкції",
        "faqResults": "Питання та відповіді",
        "noResults": "Нічого не знайдено",
        "noResultsHint": "Спробуйте інші ключові слова або перегляньте категорії та інструкції нижче."
    },
    "guides": {
        "backToHelp": "Назад",
        "purchase": {
            "title": "Покупка та встановлення",
            "tabs": {
                "installation": "Встановлення",
                "versions": "Версії VX / Elite",
                "troubleshooting": "Усунення несправностей"
            },
            "installation": {
                "title": "Встановлення циферблатів через додаток ConnectIQ",
                "intro": "Циферблати можна встановити на годинник через додаток Garmin ConnectIQ для Android або iOS.",
                "step1": "Підключіть годинник до телефону через Bluetooth і відкрийте додаток ConnectIQ на телефоні.",
                "step2": "Перейдіть на сторінку циферблата, який хочете встановити.",
                "step3": "Натисніть кнопку «Встановити». Циферблат потрапить у чергу завантаження та встановиться на годинник.",
                "step4": "Після встановлення з’явиться повідомлення в додатку або на годиннику, і циферблат буде доступний на пристрої.",
                "noteScreen": "Переконайтеся, що екран телефону не вимикається і додаток ConnectIQ залишається відкритим під час встановлення та оновлень.",
                "selectWatchfaceTitle": "Вибір циферблата на годиннику",
                "selectWatchfaceIntro": "Якщо циферблат встановлено, але він ще не відображається, можливо, потрібно обрати його в системному меню годинника.",
                "select1": "Натисніть і утримуйте кнопку меню на годиннику (або відповідну кнопку на сенсорних пристроях), щоб відкрити системне меню.",
                "select2": "Перейдіть до пункту «Циферблати» або «Дизайни екрана».",
                "select3": "Ви побачите список усіх встановлених циферблатів. Використовуйте кнопки вгору/вниз або сенсорний екран для навігації.",
                "select4": "Підтвердіть обраний циферблат кнопкою праворуч зверху. Циферблат тепер активний на вашому годиннику."
            },
            "versions": {
                "title": "VX та Elite — у чому різниця?",
                "sameFeatures": "Технічно обидві версії однакові й мають однакові функції. Різниця лише в способі покупки та активації.",
                "eliteTitle": "Версія Elite (Garmin Pay)",
                "elite1": "Окреме встановлення циферблата, купленого безпосередньо через Garmin Pay у магазині ConnectIQ.",
                "elite2": "Версія Elite прив’язана до вашого облікового запису Garmin. Якщо ви купите новий годинник, можна знову встановити Elite без додаткового ключа.",
                "elite3": "Garmin Pay підтримується не на всіх моделях годинників і може бути недоступний у деяких країнах.",
                "eliteNoKey": "Важливо: при покупці Elite через Garmin Pay код розблокування не надсилається. Версія Elite розблоковується одразу після покупки і не потребує коду.",
                "vxTitle": "Версія VX / з сайту",
                "vx1": "Сумісна з більшою кількістю пристроїв і часто доступна навіть там, де Garmin Pay недоступний.",
                "vx2": "Має вбудований безкоштовний пробний період у кілька днів.",
                "vx3": "Після пробного періоду можна придбати код розблокування на цьому сайті для постійної розблоковки версії VX (або її про-функцій).",
                "vx4": "Код розблокування завжди дійсний лише для пристрою, для якого він куплений (WatchfaceID).",
                "vx5": "Якщо годинник замінено Garmin за гарантією, можна згенерувати новий ключ. У такому разі зверніться до підтримки через форму контакту."
            },
            "website": {
                "title": "Покупка через сайт (VX / звичайні версії)",
                "step1": "Спочатку встановіть циферблат на годинник (див. вкладку Встановлення). WatchfaceID з’являється в налаштуваннях циферблата лише після встановлення.",
                "step2": "Відкрийте налаштування циферблата (через додаток ConnectIQ або Garmin Express) і скопіюйте WatchfaceID з верхнього поля.",
                "step3": "На цьому сайті оберіть відповідний циферблат і введіть свій WatchfaceID у форму покупки.",
                "step4": "Завершіть оплату. Ви отримаєте код розблокування електронною поштою і зможете ввести його в поле ключа в налаштуваннях циферблата.",
                "noteNoAutoInstall": "Важливо: покупка коду розблокування через сайт не встановлює циферблат автоматично. Кроки встановлення вище потрібно виконати вручну."
            },
            "troubleshooting": {
                "installationTitle": "Проблеми з встановленням (черга / зависання оновлень)",
                "installationIntro": "Іноді встановлення не вдається, циферблат довго залишається в черзі або додаток ConnectIQ показує нескінченні оновлення.",
                "installationCause": "Зазвичай це пов’язано з додатком ConnectIQ або сервісами Garmin, а не з самим циферблатом.",
                "installationFix1": "Перезавантажте годинник і перезапустіть додаток ConnectIQ на телефоні.",
                "installationFix2": "Спробуйте встановлення знову і переконайтеся, що екран телефону не вимикається, а додаток ConnectIQ залишається відкритим під час процесу.",
                "garminPayTitle": "Покупка через Garmin Pay зависла «в процесі»",
                "garminPayText": "Якщо покупка через Garmin Pay у магазині ConnectIQ довго залишається в стані «в процесі», це повністю обробляється Garmin. Як розробник, ми не можемо впливати на систему Garmin Pay. У такому разі зверніться до офіційної підтримки Garmin.",
                "noKeyTitle": "Я не отримав ключ розблокування після покупки на сайті",
                "noKey1": "Спочатку перевірте папку «Спам» у пошті. Листи з ключами часто потрапляють туди.",
                "noKey2": "Часто доставці заважає помилка в адресі електронної пошти. Якщо листа немає, зверніться до нас.",
                "noKey3": "та вкажіть адресу електронної пошти, яку використовували для оплати, і за можливості WatchfaceID.",
                "noKeyElite": "Примітка: при покупці версії Elite безпосередньо через Garmin Pay у магазині ConnectIQ код розблокування не надсилається. Версія Elite розблоковується одразу після покупки і не потребує коду."
            },
            "contactLink": "Форма контакту"
        },
        "timezones": {
            "title": "Часові пояси та зміщення UTC",
            "basicsTitle": "Що таке 2-й та 3-й часові пояси?",
            "basicsText": "У багатьох циферблатах можна налаштувати два додаткові часові пояси. Вони зазвичай називаються «Другий часовий пояс» та «Третій часовий пояс» і відображаються в окремих полях на циферблаті.",
            "offsetTitle": "Налаштування зміщень UTC",
            "offsetIntro": "У налаштуваннях циферблата зазвичай є поле, де можна ввести зміщення другого та третього часового поясу в хвилинах відносно UTC.",
            "offsetFormat": "Перше значення — зміщення для другого поясу, друге — для третього. Значення вводяться в хвилинах через пробіл. Плюс не додається автоматично, тому додатні значення вводьте без +.",
            "exampleLabel": "Приклад:",
            "exampleExplanation": "Тут другий пояс має зміщення −4,5 год (−270 хв), третій — +2 год (+120 хв) відносно UTC.",
            "changeExample": "Якщо потрібно змінити другий пояс на +6 год, перше значення має бути 360 (6 × 60). У прикладі вище це дасть:",
            "advancedTitle": "Розширені опції (суфікс A/B/C)",
            "advancedOptionalHint": "Цей розділ необов’язковий. Актуальний лише якщо циферблат підтримує суфікси формату A/B/C.",
            "advancedIntro": "Чи підтримує ваш циферблат ці суфікси, зазначено в описі над полем зміщення в налаштуваннях. Якщо підтримує, опис може бути таким:",
            "advancedExample": "Зміщення UTC 2-го та 3-го поясу в хвилинах (через пробіл) (літери після зміщень: A — 12-годинний формат, B — 24-годинний, C — військовий, порожньо — стандарт)",
            "advancedNote": "Ці необов’язкові літери (A/B/C) керують форматом відображення відповідного поясу в деяких циферблатах. Використовуйте їх лише якщо опис циферблата це передбачає і вам потрібен інший формат часу. Більшості достатньо лише числових зміщень без літер.",
            "exampleSectionTitle": "Покроково: приклад для різних міст і форматів",
            "exampleIntro": "Нижче показано, як задати другий пояс (наприклад, Нью-Йорк) і третій (наприклад, Токіо) та за бажанням обрати 12-годинний або 24-годинний формат для кожного.",
            "exampleStep1Title": "Крок 1: зміщення UTC для 2-го поясу",
            "exampleStep1Text": "Визначте місто або регіон для другого поясу. Переведіть різницю часу відносно UTC у хвилини. Приклад: Нью-Йорк (EST, UTC−5) → −300 хв. Введіть це як перше значення в налаштуваннях.",
            "exampleStep2Title": "Крок 2: зміщення UTC для 3-го поясу",
            "exampleStep2Text": "Те саме для третього поясу. Приклад: Токіо (JST, UTC+9) → 540 хв. Це друге значення, через пробіл після першого.",
            "exampleOnlyOffsets": "Якщо циферблат не використовує суфікси A/B/C, на цьому все. Введіть:",
            "exampleStep3Title": "Крок 3: необов’язковий суфікс формату (A/B/C)",
            "exampleStep3Optional": "Цей крок необов’язковий: суфікси можна не вказувати навіть якщо циферблат їх підтримує — тоді використовується формат за замовчуванням. Щоб примусово задати 12-годинний, 24-годинний або військовий формат для поясу, додайте літеру одразу після зміщення — без пробілу між зміщенням і суфіксом.",
            "exampleStep3Text": "Приклад: 12-годинний формат для Нью-Йорка (A) і 24-годинний для Токіо (B):",
            "exampleStep3Note": "Без суфікса використовується формат за замовчуванням циферблата (часто 24-годинний). Чи підтримуються суфікси, зазначено в описі над полем зміщення в налаштуваннях.",
            "exampleFormatTitle": "Як відображається час при A, B, C",
            "exampleFormatIntro": "Для того самого моменту часу відображення відрізняється за форматом (приклад: 2-й пояс Нью-Йорк -300, 3-й Токіо 540). Живий перегляд:",
            "zone2": "2-й пояс",
            "zone3": "3-й пояс",
            "exampleTableTitle": "Довідка: зміщення UTC для обраних міст (хвилини)",
            "exampleTableIntro": "Стандартний час; літній час може відрізнятися. Помножте години на 60."
        },
        "switchViews": {
            "title": "Перемикання видів та жести",
            "wordLabel": "перемикання виду",
            "basicsTitle": "Що таке перемикання видів?",
            "basicsText": "Багато циферблатів можуть показувати різну інформацію в одній і тій самій зоні екрана. Ці альтернативні сторінки часто називають «Switchview» ({{wordLabel}}), «Switchview 2», «Верхній вид 1/2», «Нижній вид 1/2» тощо в налаштуваннях циферблата.",
            "proNote": "Часто ці додаткові види є про-функціями, доступними під час пробного періоду і потребують ключа активації після нього.",
            "gestureTitle": "Зміна видів жестом руки",
            "gestureIntro": "На годинниках без сумісного сенсорного екрану альтернативні види можна змінювати другим рухом руки.",
            "gestureStep1": "Підніміть руку як зазвичай, щоб розблокувати екран. Секунди або підсвічений екран показують, що годинник у активному режимі.",
            "gestureStep2": "Протягом кількох секунд (близько 7) зробіть рух рукою знову — не надто різко, але достатньо чітко, щоб годинник розпізнав його як другий жест.",
            "gestureStep3": "Якщо циферблат підтримує перемикання видів, налаштовані зони (наприклад, верхній або нижній вид) перемкнуться на наступну сторінку.",
            "gestureHint": "Якщо нічого не змінюється, перевірте налаштування циферблата: деякі види потрібно явно призначити (наприклад «Верхній вид 2» / «Нижній вид 2»).",
            "touchTitle": "Перемикання видів на сенсорних пристроях",
            "touchIntro": "На новіших годинниках з сумісним сенсорним екраном (наприклад Fenix 7 і новіших) види часто можна змінювати натисканням певних зон.",
            "touchConfig": "У багатьох циферблатах ці зони можна налаштувати в параметрах, часто нижче в списку. Типові приклади — цифри годин і хвилин часу або окремі області на екрані.",
            "touchHold": "Якщо зона натискання налаштована, довге натискання на відповідну цифру/область перемикає призначений вид.",
            "touchMultiple": "Деякі циферблати мають кілька зон, які можна призначити окремо — наприклад одну для верхнього виду і одну для нижнього.",
            "touchInfo": "Якщо для циферблата є спеціальні зони, вони зазвичай описані в інформаційному тексті циферблата на цьому сайті або в магазині ConnectIQ."
        },
        "findWfId": {
            "title": "Як знайти свій WatchfaceID",
            "whatIs": "Що таке WatchfaceID?",
            "whatIsExplanation": "Кожен циферблат має унікальний WatchfaceID для кожного пристрою. Це 5–6-значне число. Цей ID потрібен для покупки коду активації або для звернення до підтримки.",
            "connectIqTitle": "Через додаток ConnectIQ (рекомендовано)",
            "ciq1": "Переконайтеся, що годинник підключено до телефону через Bluetooth.",
            "ciq2": "Відкрийте додаток ConnectIQ на телефоні.",
            "ciq3": "Перейдіть на сторінку циферблата з описом та зображеннями. Якщо не знаходите — скористайтеся рядком «Пошук» внизу або розділом «Мої циферблати» у «Пристрій».",
            "ciq4": "Натисніть кнопку «Налаштування» на сторінці циферблата, щоб відкрити всі параметри.",
            "ciq5": "WatchfaceID показано у верхньому полі. Скопіюйте або введіть це число — це ID, потрібний для оплати.",
            "keyEntryTitle": "Введення ключа активації",
            "keyEntryExplanation": "У рядку під полем WatchfaceID знаходиться поле для ключа/коду, який надсилається після оплати. У деяких циферблатах там показується кількість днів пробного періоду — видаліть це перед введенням ключа.",
            "garminExpressTitle": "Через Garmin Express (комп’ютер)",
            "ge1": "Встановіть Garmin Express і підключіть годинник до комп’ютера.",
            "ge2": "Перейдіть до списку встановлених циферблатів.",
            "ge3": "Натисніть кнопку з трьома крапками біля запису циферблата, щоб відкрити налаштування.",
            "ge4": "Далі дійте так само, як у додатку ConnectIQ.",
            "geNote": "Примітка: рекомендується додаток ConnectIQ, оскільки деякі версії Garmin Express можуть викликати помилки.",
            "zeroId": "WatchfaceID показує 0?",
            "zeroIdExplanation": "Іноді WatchfaceID показує 0. Зазвичай допомагає одне збереження налаштувань або перезавантаження годинника. Якщо після цього все ще 0, оплата має працювати."
        },
        "location": {
            "title": "Налаштування GPS та локації",
            "whatIsGpsFix": "Що таке GPS-фіксація?",
            "gpsFixExplanation": "GPS-фіксація повідомляє циферблату ваше місцезнаходження, щоб він міг коректно обчислювати час сходу/заходу сонця, фази місяця, локацію погоди та припливи.",
            "howTo": "Як виконати GPS-фіксацію",
            "step1": "На годиннику перейдіть на екран запуску будь-якої активності (наприклад «Біг»)",
            "step2": "Дочекайтеся, поки годинник отримає GPS-сигнал (зелена смуга/іконка)",
            "step3": "Поверніться на циферблат — дані мають оновитися протягом кількох хвилин",
            "alternative": "Альтернатива: GPS телефону",
            "alternativeExplanation": "Можна також увімкнути GPS на телефоні. Годинник має бути підключено через Bluetooth. Цей спосіб повільніший, але так само працює.",
            "requirements": "Вимоги",
            "req1": "Годинник підключено до телефону через Bluetooth",
            "req2": "Додаток Garmin Connect (не ConnectIQ) працює щонайменше у фоні",
            "req3": "Увімкнений GPS на телефоні для локації через телефон"
        },
        "settings": {
            "tabs": { "options": "Опції полів даних", "change": "Змінити налаштування", "troubleshoot": "Усунення несправностей" },
            "title": "Налаштування циферблата",
            "optionsIntro": "Загальний список опцій полів даних. Натисніть для опису. Не всі опції доступні на всіх циферблатах.",
            "change": {
                "title": "Як змінити налаштування циферблата",
                "intro": "Налаштування циферблата змінюються в додатку ConnectIQ на телефоні.",
                "step1": "Підключіть годинник до телефону через Bluetooth і відкрийте додаток ConnectIQ (не Connect).",
                "step2": "Перейдіть на сторінку циферблата. Якщо не встановлено — спочатку встановіть.",
                "step3": "На сторінці циферблата натисніть кнопку «Налаштування» — відкриється список.",
                "step4": "Тут можна змінити всі поля даних, кольори та додаткові опції.",
                "step5": "Натисніть кнопку збереження у правому верхньому куті, щоб передати налаштування на годинник.",
                "installLink": "Інструкція з установки"
            },
            "troubleshoot": {
                "title": "Усунення несправностей",
                "cantSave": { "q": "Налаштування не зберігаються", "a1": "Іноді сервери Garmin не обробляють деякі символи.", "a2": "Очистіть поле кольорової схеми (якщо є) і збережіть знову." },
                "wontOpen": { "q": "Налаштування не відкриваються", "a1": "Повністю закрийте додаток ConnectIQ і за потреби перезапустіть годинник.", "a2": "Якщо бачите лише кнопку «Встановити» — циферблат ще не встановлено." },
                "missingOptions": { "q": "Не можу знайти потрібну опцію", "a": "Не всі опції доступні на всіх пристроях." },
                "naValue": { "q": "У полі відображається лише «n/a»", "a": "Ваш пристрій не підтримує цю опцію (старіша модель або відсутнє обладнання)." }
            }
        },
        "dateFormat": {
            "title": "Власний формат дати (Дата 1 / 2 / 3)",
            "basicsTitle": "Для чого поля формату дати?",
            "basicsIntro": "У налаштуваннях циферблата є два (або три) поля, якими налаштовується відображення Дати 1, Дати 2 і за наявності Дати 3. Введені літери задають формат.",
            "notAll": "Доступно не на всіх циферблатах.",
            "where": "Поля зазвичай знаходяться нижче в налаштуваннях, під опціями полів даних.",
            "codesTitle": "Коди формату",
            "codesIntro": "У полі формату можна використовувати такі літери. Результат відповідає поточній даті.",
            "codeD": "день місяця (з провідним нулем)",
            "codeDText": "день тижня текстом (напр. понеділок)",
            "codeM": "місяць числом (з провідним нулем)",
            "codeMText": "місяць текстом",
            "codeY": "рік двома цифрами",
            "codeY4": "рік чотирма цифрами",
            "codeJ": "юліанська дата (військова)",
            "codeW": "номер тижня",
            "codeO": "місяць без провідного нуля",
            "codeN": "день без провідного нуля",
            "codeP": "день року",
            "exampleHint": "Напр. «D, d.M.Y» може показати «Пн, 27.02.2026»."
        }
    },
    "newsletter": {
        "title": "Розсилка",
        "description": "Підпишіться, щоб отримувати новини про нові циферблати, функції та акції.",
        "frequencyHint": "Приблизно один лист на два місяці. Можна відписатися в будь-який час.",
        "emailPlaceholder": "Ваша електронна пошта",
        "subscribe": "Підписатися",
        "unsubscribe": "Відписатися",
        "subscribeSuccess": "Підписку оформлено! Перевірте пошту.",
        "subscribeError": "Сталася помилка. Спробуйте пізніше.",
        "unsubscribeSuccess": "Відписку виконано.",
        "unsubscribeError": "Сталася помилка. Спробуйте пізніше."
    },
    "contact": {
        "title": "Контакт",
        "description": "Є питання чи потрібна допомога? Напишіть мені.",
        "emailLabel": "Електронна пошта",
        "emailPlaceholder": "ваша@пошта.com",
        "deviceLabel": "Пристрій (необов’язково)",
        "devicePlaceholder": "наприклад Fenix 7",
        "watchfaceLabel": "Циферблат (необов’язково)",
        "watchfacePlaceholder": "наприклад Horizon",
        "messageLabel": "Повідомлення",
        "messagePlaceholder": "Ваше повідомлення...",
        "send": "Надіслати",
        "sendAnother": "Написати ще",
        "successTitle": "Повідомлення надіслано!",
        "successMessage": "Я відповім якомога швидше.",
        "error": "Сталася помилка. Спробуйте знову або напишіть напряму на dev@orcatec.net.",
        "consentNotice": "Надсилаючи форму, ви погоджуєтесь на обробку даних згідно з нашою",
        "guidesIntro": "Якщо є питання щодо окремих функцій, відповіді можуть бути в цих інструкціях:",
        "faqIntro": "З багатьма темами також є детальні питання та відповіді:",
        "faqLinkLabel": "Відкрити допомогу та інструкції",
        "responseTimeNotice": "Будь ласка, врахуйте, що в завантажені періоди відповідь іноді може зайняти кілька днів."
    },
    "refund": {
        "title": "Політика повернення коштів"
    },
    "terms": {
        "title": "Умови використання"
    },
    "privacy": {
        "title": "Політика конфіденційності"
    },
    "footer": {
        "description": "Сучасні додатки Garmin з розширеними функціями для всіх активностей.",
        "tagline": "Сучасні додатки Garmin з розширеними функціями для всіх активностей.",
        "linksTitle": "Посилання",
        "socialsTitle": "Соцмережі",
        "terms": "Умови використання",
        "impressum": "Імпресум",
        "privacy": "Конфіденційність",
        "refund": "Повернення коштів",
        "contact": "Контакт",
        "rights": "Усі права захищено.",
        "links": "Посилання",
        "contactDescription": "Питання чи підтримка?",
        "contactLink": "Написати нам",
        "copyright": "Orcatec - TitanicTurtle. Усі права захищено.",
        "garminForums": "Форуми Garmin"
    },
    "tides": {
        "title": "Припливи через Stormglass.io",
        "intro": "Щоб використовувати припливи на циферблаті з провайдером stormglass, потрібно зареєструватися на їхньому сайті та отримати API-ключ, який можна ввести в відповідне поле в налаштуваннях циферблата.",
        "apiKey": {
            "title": "Копіювання API-ключа",
            "description": "Копіюючи API-ключ, переконайтеся, що скопійовані всі символи (зазвичай понад 60) — іноді Android/iOS обрізає частину після «-»."
        },
        "freePlan": {
            "title": "Безкоштовний план",
            "description": "Безкоштовний план (stormglass io) дає 10 безкоштовних запитів на день, що достатньо для підтримки припливів у циферблатах TitanicTurtle.",
            "note": "(Якщо ваш циферблат підтримує stormglass io як провайдера погоди і ви плануєте його використовувати, може знадобитися окремий план підписки)"
        },
        "dataDownload": {
            "title": "Завантаження даних",
            "description": "Зазвичай дані припливів завантажуються на кілька днів і оновлюються щодня за наявності підключення телефону. Тому навіть без інтернету очікуйте відображення припливів щонайменше на 3 (Horizon) / 5 (Centurion) дні. (залежить від циферблата та пристрою)"
        },
        "initialSetup": {
            "title": "Початкове налаштування",
            "description": "Після введення API-ключа stormglass io в налаштуваннях до завантаження та появи даних може пройти до 30 хвилин."
        },
        "locationUpdate": {
            "title": "Оновлення локації",
            "description": "При зміні місцезнаходження обов’язково отримайте GPS-сигнал на годиннику, щоб дані припливів оновилися для нового місця."
        },
        "requirements": {
            "title": "Вимоги",
            "bluetooth": "Переконайтеся, що годинник підключено до телефону через Bluetooth, а додаток Connect (не Connect IQ) щонайменше працює у фоні.",
            "gps": {
                "title": "GPS-фіксація",
                "description": "Якщо на годиннику з’являється повідомлення на кшталт «GPS?», виконайте GPS-фіксацію, щоб циферблат знав ваше місце.",
                "steps": {
                    "step1": "Перейдіть на екран запуску активності, наприклад «Біг», на годиннику",
                    "step2": "Дочекайтеся отримання GPS-сигналу годинником"
                }
            }
        }
    },
    "common": {
        "loading": "Завантаження...",
        "error": "Помилка",
        "retry": "Спробувати знову",
        "back": "Назад",
        "close": "Закрити",
        "save": "Зберегти",
        "cancel": "Скасувати",
        "confirm": "Підтвердити",
        "notFound": "404 — Сторінку не знайдено"
    },
    "watchfacesOverview": {
        "title": "Усі додатки",
        "loading": "Завантаження циферблатів...",
        "error": "Помилка завантаження циферблатів",
        "retry": "Спробувати знову",
        "noWatchfaces": "Циферблатів немає"
    },
    "detailTabs": {
        "payment": "Оплата",
        "themes": "Теми",
        "info": "Інформація",
        "instructions": "Інструкції",
        "instructionsIntro": "Усі інструкції та поради в одному місці:",
        "noThemes": "Для цього циферблата немає кольорових тем."
    },
    "watchfaceDetail": {
        "loading": "Завантаження циферблата...",
        "error": {
            "notFound": "Циферблат не знайдено",
            "loading": "Помилка завантаження циферблата"
        },
        "backToOverview": "Назад до списку",
        "goToStore": "Перейти в магазин IQ",
        "goToTrial": "Пробна версія",
        "devices": "пристроїв",
        "info": {
            "title": "Функції",
            "tides": "🌊 Інформація про припливи з автоматичним оновленням",
            "weather": "🌤️ Погода від OpenWeatherMap та Yr",
            "colors": "🎨 Кольорові теми та налаштування",
            "location": "📍 Визначення локації за GPS",
            "faq": "❓ Питання та підтримка",
            "weatherFallback": "Якщо введено ключ OpenWeatherMap без підписки One Call 3.0, використовується резервний провайдер погоди «Yr»."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Як працюють теми:",
            "description": "У верхній частині налаштувань циферблата є «рядок теми», який відображає поточні кольорові налаштування (іконки, графіки, час тощо). Якщо щось змінити (наприклад колір верхньої секції) і натиснути «Зберегти», рядок теми оновиться при наступному відкритті налаштувань. Так можна зберегти кольорові налаштування, скопіювавши та зберігши рядок теми деінде. Його можна ділитися з іншими (наприклад у відгуках чи на форумі) і застосовувати чужі рядки тем для інших стилів."
        },
        "dynamicThemeSwitching": {
            "title": "Динамічна зміна теми:",
            "sunset": {
                "title": "Зміна після заходу / перед східом сонця —",
                "description": "якщо поставити знак оклику ! перед рядком теми в полі рядка теми, він збережеться як тема, на яку перемикатиметься після заходу сонця (приклад: !UEUE[UEUEEEEEEU^). Змінити можна в будь-який час, ввівши рядок теми з ! на початку. Щоб прибрати нічну тему, введіть лише ! у полі — тоді перемикання припиниться."
            },
            "lowPower": {
                "title": "Зміна в режимі енергозбереження —",
                "description": "процес такий самий, як для теми заходу/сходу вище, але замість ! поставте # перед рядком теми (приклад: #UEUE[UEUEEEEEEU^). Кожен годинник переходить у «режим енергозбереження» приблизно через 10 секунд після того, як ви дивитесь на екран або повертаєтесь з меню. Зазвичай у цьому режимі секунди зникають (це можна змінити в налаштуваннях циферблата). Обидва варіанти (@ніч/@енергозбереження) можна комбінувати. Після налаштування динамічний рядок теми не відображається в налаштуваннях — краще зберегти його деінде, якщо плануєте зміни в майбутньому."
            }
        }
    },
    "colorThemes": {
        "clickToCopy": "Натисніть, щоб скопіювати",
        "clickToPreview": "Натисніть для перегляду",
        "closePreview": "Закрити перегляд",
        "copied": "Скопійовано!",
        "useInSettings": "Використовуйте в налаштуваннях циферблата",
        "guideLink": "Детальніше про теми та рядки тем",
        "deviceNote": "Примітка: кольорові теми доступні не на всіх пристроях.",
        "noFieldNote": "Якщо в налаштуваннях циферблата немає окремого поля для кольорових схем, значить вони не підтримуються для вашої моделі годинника на цьому циферблаті."
    },
    "payment": {
        "option1": {
            "title": "Спосіб оплати 1: Garmin Pay",
            "description": "Купіть платний циферблат безпосередньо через Garmin Pay у магазині ConnectIQ (якщо ваш годинник підтримується).",
            "link": "Перейти в магазин ConnectIQ"
        },
        "option2": {
            "title": "Спосіб оплати 2: Пряма оплата за WatchfaceID",
            "description": "Якщо ваш годинник не підтримує платну про-версію, можна придбати ключ для пробної/VX версії, ввівши свій WatchfaceID.",
            "vxNote": "Це ключ для VX версії циферблата, не для версії Garmin Pay!",
            "vxLink": "Посилання на VX версію"
        },
        "tax": "податок",
        "wfid": {
            "description": "Введіть свій WatchfaceID (знаходиться в налаштуваннях циферблата)",
            "placeholder": "Введіть WatchfaceID (5–6 цифр)",
            "guideLink": "Як знайти свій WatchfaceID",
            "guideLinkShort": "Показати інструкцію"
        },
        "wfidError": {
            "letters": "WatchfaceID має містити лише цифри",
            "tooLong": "WatchfaceID має бути 5–6 цифр",
            "invalid": "Введіть коректний WatchfaceID (5–6 цифр)",
            "lengthHint": "WatchfaceID зазвичай складається з 5–6 цифр. Перевірте ще раз."
        },
        "errors": {
            "empty": "Введіть WatchfaceID",
            "invalid": "Введіть коректний WatchfaceID",
            "config": "Помилка конфігурації оплати",
            "checkout": "Не вдалося відкрити оплату. Спробуйте знову."
        },
        "buy": "Купити зараз",
        "selectMethod": "Оберіть вашу версію",
        "versionSelectHint": "Це дві окремі версії — будь ласка, оберіть правильну:",
        "vxWarning": "VX та Elite — це окремо завантажувані версії циферблата. Код активації для VX версії НЕ розблоковує версію Elite.",
        "beta": {
            "title": "Зараз у бета-версії",
            "description": "Під час бета-фази циферблат повністю безкоштовний. Після тестового періоду автоматичних списань не буде. У цей час тестуються нові функції. Дякуємо за відгуки!",
            "descriptionApp": "Під час бета-фази додаток повністю безкоштовний. Після тестового періоду автоматичних списань не буде. У цей час тестуються нові функції. Дякуємо за відгуки!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Версія Elite",
            "description": "Цей циферблат доступний лише через Garmin Pay у магазині ConnectIQ.",
            "comboDescription": "Купівля безпосередньо через Garmin Pay у магазині ConnectIQ. Це окрема, самостійна версія.",
            "compatibility": "Примітка: не всі моделі годинників підтримують Garmin Pay. Перевірте сумісність на сторінці магазину. Інакше завантажте VX версію (технічно ідентичну).",
            "storeLink": "Відкрити в магазині ConnectIQ",
            "moreGuide": "Потрібні деталі про різницю між Elite та VX?",
            "moreGuideLink": "Читати інструкцію з покупки та встановлення",
            "eliteNoKey": "При покупці Elite через Garmin Pay код розблокування не надсилається. Elite розблоковується одразу після покупки і не потребує коду.",
            "accountBound": "Покупка через Garmin Pay прив'язана до вашого облікового запису Garmin і автоматично доступна для ваших майбутніх пристроїв (якщо сумісні).",
            "eliteNoKeyAndGuide": "При покупці через Garmin Pay код розблокування не надсилається — Elite розблоковується одразу після покупки. Детальніше в інструкції з покупки та встановлення."
        },
        "vx": {
            "badge": "Усі пристрої",
            "title": "VX версія",
            "description": "Сумісна з усіма підтримуваними пристроями. Завантажте безкоштовну пробну версію з магазину ConnectIQ, потім активуйте її тут купленим кодом.",
            "trialNote": "VX версія має безкоштовний пробний період. Після нього придбайте код активації нижче для постійної розблоковки.",
            "deviceBound": "Код активації прив'язаний до вашого пристрою і розблоковує VX версію назавжди.",
            "moreGuide": "Потрібні деталі про VX, ключі чи встановлення?",
            "moreGuideLink": "Читати інструкцію з покупки та встановлення",
            "downloadLink": "Завантажити VX версію",
            "details": {
                "line1": "Після успішної оплати ключ активації буде надіслано на вказану на наступному кроці електронну пошту.",
                "line2": "Переконайтеся, що адреса електронної пошти правильна.",
                "line3": "Після оплати перевірте папку «Спам» — листи з ключами часто потрапляють туди.",
                "line4": "Усі способи оплати обробляються через Paddle — обліковий запис не потрібен.",
                "line5": "Для запитів у підтримку використовуйте форму контакту або інструмент магазину ConnectIQ.",
                "line6": "Інші запити не обробляються."
            }
        },
        "standalone": {
            "title": "Придбати код активації",
            "description": "Придбайте код активації, ввівши свій WatchfaceID нижче. Код буде надіслано одразу."
        },
        "checkoutOpening": "Відкриття оплати...",
        "info": {
            "key": "Після покупки ви отримаєте ключ для введення в налаштуваннях циферблата.",
            "activation": "Ключ активується одразу після успішної оплати.",
            "support": "За питаннями звертайтесь до підтримки.",
            "moreGuide": "Детальніше про покупку та встановлення"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Кредитна картка"
        }
    },
    "fonts": {
        "title": "Шрифти",
        "timefonts": "Шрифти часу",
        "datafonts": "Шрифти даних"
    },
    "weather": {
        "title": "Провайдери погодних даних",
        "intro": "Для багатьох циферблатів на більшості пристроїв є вибір різних провайдерів погоди. Провайдера можна змінити в налаштуваннях додатку ConnectIQ. Зазвичай за замовчуванням обрано погоду Garmin або Yr.",
        "noData": "Якщо в полі погоди показується «немає даних», дані не вдалося завантажити. Нижче — кроки для отримання погоди на годиннику.",
        "tabs": {
            "garmin": "Garmin",
            "yr": "Yr",
            "openweathermap": "OpenWeatherMap",
            "visualcrossing": "Visual Crossing",
            "location": "Локація"
        },
        "garmin": {
            "title": "Використання погоди Garmin:",
            "description": "Якщо пристрій підтримує погоду Garmin, достатньо підключити годинник до телефону через Bluetooth і переконатися, що додаток Connect (не Connect IQ) щонайменше працює у фоні та має доступ до поточної локації телефону. (Поточна локація (GPS) має бути увімкнена)",
            "download": "Годинник автоматично завантажить погодні дані з цього сервісу — це може зайняти кілька хвилин.",
            "check": "Можна також перевірити, чи вже показує погоду вбудований віджет погоди Garmin на годиннику. Якщо там немає даних, циферблат їх теж не покаже — це той самий джерело.",
            "noApiKey": "Для погоди Garmin додатковий API-ключ не потрібен.",
            "location": "У деяких циферблатах при використанні погоди Garmin також показується надана локація. У Garmin це зазвичай найближчий аеродром — точніше місце можливе лише з іншими провайдерами.",
            "update": "Локація оновлюється, як тільки дані локації стають активними на телефоні.",
            "noData": "Якщо погоду не показує або не оновлює — з’являється «немає даних»: виконайте кроки вище.",
            "missingData": {
                "title": "Чого немає в погоді Garmin:",
                "airQuality": "Якість повітря",
                "uvIndex": "UV-індекс",
                "description": "Опис погоди"
            }
        },
        "yr": {
            "title": "Використання Yr:",
            "description": "Yr — сервіс Норвезького метеорологічного інституту та NRK; можна використовувати без API-ключа.",
            "setup": "Щоб отримувати погоду з Yr, оберіть його провайдером погоди та підключіть годинник до телефону через Bluetooth.",
            "connectApp": "На телефоні переконайтеся, що додаток Connect (не ConnectIQ) щонайменше працює у фоні — годинник через нього завантажує погоду з інтернету.",
            "interval": "Якщо у циферблата є налаштування інтервалу оновлення, при Yr можливий мінімум 10 хвилин.",
            "noData": {
                "title": "немає даних / неправильна локація:",
                "description": "Якщо погоду не завантажено або локація неправильна, допоможе оновлення збереженої локації циферблата.",
                "fix": "Перейдіть на екран запуску активності, наприклад «Біг», на годиннику і дочекайтеся GPS-сигналу. Погода та локація мають оновитися протягом кількох хвилин."
            },
            "missingData": {
                "title": "Чого немає в Yr:",
                "airQuality": "Якість повітря"
            }
        },
        "openweathermap": {
            "title": "Використання OpenWeatherMap:",
            "description": "Якщо ваш циферблат підтримує OpenWeatherMap і ви хочете його використовувати, потрібен безкоштовний API-ключ з їхнього сайту:",
            "setup": "Після отримання ключа введіть його у відповідне поле в налаштуваннях циферблата. (щойно згенерований ключ може запрацювати через кілька годин)",
            "connect": "Переконайтеся, що годинник підключено до телефону через Bluetooth, а додаток Connect (не Connect IQ) щонайменше працює у фоні для завантаження погоди.",
            "gps": "Якщо на годиннику з’являється «GPS?», виконайте GPS-фіксацію, щоб циферблат знав ваше місце. (Перейдіть на екран запуску активності «Біг» і дочекайтеся GPS-сигналу)",
            "uv": {
                "title": "UV-індекс / опади в OpenWeatherMap:",
                "oldKey": "Якщо у вас старий API-ключ (згенерований до ~лютого 2023), ці показники працюють без обмежень.",
                "newKey": "Якщо ключ згенеровано після цієї дати і потрібні ці показники від OpenWeatherMap, може знадобитися додаткова (безкоштовна) підписка — план «One Call by Call».",
                "limit": "Перші 1000 запитів на день за цією підпискою безкоштовні, ліміт можна встановити на 1000 — цього більш ніж достатньо для погоди на весь день для будь-якого з моїх циферблатів."
            },
            "select": "Якщо циферблат підтримує кілька сторонніх провайдерів, оберіть OpenWeatherMap у випадаючому меню в налаштуваннях циферблата."
        },
        "visualcrossing": {
            "title": "Використання Visual Crossing:",
            "description": "Для Visual Crossing потрібно зайти на їхній сайт і отримати безкоштовний API-ключ.",
            "setup": "Після отримання ключа введіть його у відповідне поле в налаштуваннях циферблата та оберіть Visual Crossing провайдером погоди у випадаючому меню.",
            "connect": "Переконайтеся, що годинник підключено до телефону через Bluetooth, а додаток Connect (не Connect IQ) щонайменше працює у фоні для завантаження погоди.",
            "gps": "Якщо на годиннику з’являється «GPS?», виконайте GPS-фіксацію, щоб циферблат знав ваше місце. (Перейдіть на екран запуску активності «Біг» і дочекайтеся GPS-сигналу)"
        },
        "location": {
            "title": "Оновлення локації",
            "description": "Щоб погода відображалася правильно, циферблату потрібна ваша поточна локація. Вона визначається через GPS.",
            "gpsFix": {
                "title": "Виконати GPS-фіксацію:",
                "description": "Якщо на годиннику з’являється «GPS?», потрібно виконати GPS-фіксацію, щоб циферблат знав ваше місце.",
                "step1": "Перейдіть на екран запуску активності «Біг» на годиннику",
                "step2": "Дочекайтеся отримання GPS-сигналу годинником",
                "step3": "Поверніться на циферблат — погода має оновитися протягом кількох хвилин"
            },
            "requirements": {
                "title": "Вимоги:",
                "bluetooth": "Годинник має бути підключено до телефону через Bluetooth",
                "connectApp": "Додаток Connect (не Connect IQ) має працювати щонайменше у фоні",
                "gps": "На телефоні має бути увімкнений GPS"
            }
        }
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Додаток Bierwandern дозволяє відстежувати похід і «доповнення», якими ви насолоджуєтесь у дорозі. Також є оцінка проміле з графіком (приблизна) – але, будь ласка, не сприймайте це занадто серйозно!",
        "settingsHint": "На стартовому екрані натисніть кнопку меню на годиннику, щоб відкрити налаштування (на годинниках із двома кнопками – довге натискання на сенсорний екран).",
        "disclaimer": "Розрахунок проміле – чисто розважальна метрика, алгоритм оцінює алкоголь у крові за спожитими напоями та вагою тіла! Не приймайте рішень на основі цього значення – воно ненадійне і не є справжнім вимірюванням алкоголю!",
        "closing": "А в решті речей бажаю вам чудових походів і гарного настрою!",
        "support": "З проблемами або пропозиціями скористайтеся кнопкою «App Support» – дякую."
    },
    "bodysurf": {
        "intro": {
            "title": "Що таке BodySurf?",
            "text": "BodySurf — додаток Garmin Connect IQ для бодісерфінгу. Він використовує GPS для визначення заїзду на хвилі, вимірює відстань і тривалість кожного заїзду та присвоює веселий титул за пройденою відстанню. Сесії зберігаються як активності з окремими колами в Garmin Connect."
        },
        "gps": {
            "title": "Перед стартом – GPS",
            "text1": "Зачекайте на GPS-фікс перед початком сесії. На стартовому екрані буде «Пошук GPS», потім «START, щоб почати».",
            "text2": "Для кращої точності додаток використовує multi-GNSS / dual-band GPS, якщо годинник підтримує. Постійте нерухомо біля води, якщо фікс триває довго."
        },
        "start": {
            "title": "Екран початку",
            "startBtn": "Почніть нову сесію, коли GPS готовий (START = почати сесію).",
            "menuBtn": "Відкрийте налаштування: Як користуватися та Одиниці (MENU = налаштування / інформація).",
            "backBtn": "BACK = вийти з програми"
        },
        "during": {
            "title": "Під час активності",
            "detect": "Поїздки визначаються за GPS швидкість автоматично. Використовуйте BACK для ручного старту/зупинки поїздки. Короткі рухи менше 2 метрів відкидаються.",
            "startBtn": "START = зупинити / зберегти / продовжити",
            "backBtn": "BACK = ручна їзда вкл/викл",
            "live": "Під час заїзду видно поточну відстань, живий титул і «ЇЗДИМО!». Після заїзду титул і статистика залишаються до наступного."
        },
        "stop": {
            "title": "Меню зупинки",
            "resume": "Продовжити",
            "save": "Зберегти",
            "discard": "Скасувати"
        },
        "after": {
            "title": "Після сесії",
            "summary": "Підсумок показує час сесії, кількість Поїздки, загальну відстань і Найкраще заїзд з титулом і статистикою.",
            "rides": "Проведіть, щоб побачити деталі поїздки. На годинниках з кнопками: << DOWN rides.",
            "finished": "Потім: Нова сесія через START або Вийти з програми через НАЗАД."
        },
        "titles": {
            "title": "Титули заїздів",
            "intro": "Кожна поїздка отримує цікаву назву на основі відстані. Чим довша поїздка, тим краща назва!",
            "colDistance": "Відстань",
            "colTitle": "Титул",
            "th0": "Сігурка",
            "th1": "Плоска риба",
            "th2": "Людський серфборд",
            "th3": "Серфер",
            "th4": "Аквамен",
            "th5": "Посейдон",
            "th6": "Нептун",
            "th7": "Переможець хвиль",
            "th8": "Майстер серфінгу",
            "th9": "Бог хвиль",
            "th10": "Легенда океану",
            "th11": "Титан хвиль",
            "th12": "Король океану"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Збережені сесії з’являються в Garmin Connect з полями: титул заїзду, відстань кола (метри), час кола (секунди) та найдовший заїзд/час на рівні сесії. Кожен заїзд зберігається як коло."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "На Instinct субдисплей показує час, GPS і відстань. Використовуйте кнопку ВНИЗ замість свайпу (<< DOWN rides).",
            "menu": "«Меню» зліва на стартовому екрані. Натисніть START, коли на субдисплеї GPS ОК."
        },
        "settings": {
            "title": "Налаштування",
            "units": "Одиниці: перемикання метричної та імперської систем для відстані та швидкості.",
            "info": "Інформація: вбудована довідка (Як користуватися) для кнопок під час активності, після сесії та на стартовому екрані."
        },
        "supportBefore": "З проблемами або пропозиціями скористайтеся",
        "supportLink": "формою зворотного зв'язку",
        "supportAfter": " – дякуємо!"
    }
};
